import { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from "react";
import { View } from "react-native";

export type TabProps = {
  value: string;
  children: ReactNode;
  active?: boolean;
  onPress?: () => void;
  theme?: "light" | "dark";
};

export function Tabs({
  value,
  onChange,
  children,
  theme = "light",
}: {
  value: string;
  onChange: (v: string) => void;
  children: ReactNode;
  theme?: "light" | "dark";
}) {
  const border = theme === "dark" ? "border-white/10" : "border-sand-dark";
  return (
    <View className={`flex-row border-b ${border}`}>
      {Children.map(children, (child) => {
        if (!isValidElement<TabProps>(child)) return child;
        return cloneElement(child as ReactElement<TabProps>, {
          active: child.props.value === value,
          onPress: () => onChange(child.props.value),
          theme,
        });
      })}
    </View>
  );
}
